import React from 'react';

import get from 'lodash/get';

import { getStepDefinitionType } from '../../../utils/product_utils';

import DividerDot from '../../common/misc/DividerDot';
import Label from '../../common/Labels/Label';

export const PipelineStepContent = ({ step }) => {
  const stepType = getStepDefinitionType(step);
  const isModelInferenceStep = stepType === 'ModelInference';

  const modelData = get(step, `${stepType}.models[0]`);
  const stepName = isModelInferenceStep ? modelData?.name : stepType;

  return (
    <div className="flex flex-col items-start justify-center">
      <Label bold>{stepName}</Label>
      {
        isModelInferenceStep ? (
          <div className="flex">
            <Label>{stepType}</Label>
            <DividerDot />
            <Label>{modelData?.version}</Label>
          </div>
        ) : null
      }
    </div>
  )
}

export default PipelineStepContent;
